import { render, staticRenderFns } from "./PublicSwitch.vue?vue&type=template&id=9240e364&scoped=true&lang=pug"
import script from "./PublicSwitch.vue?vue&type=script&lang=ts"
export * from "./PublicSwitch.vue?vue&type=script&lang=ts"
import style0 from "./PublicSwitch.vue?vue&type=style&index=0&id=9240e364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9240e364",
  null
  
)

export default component.exports